import React from "react";
import {Route, useLocation, useNavigate, useParams} from "react-router-dom";
import Navbar from "../../components/navbar";
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer/Footer";
import routes from "../../routes.js";
import ChatListPage from "./index";
import ChatDetailsComponent from "./chat";
import {MdNavigateBefore, MdOutlineNavigateNext} from "react-icons/md";
import {useSelector} from "react-redux";
import {applyFilters} from "../../variables/utils";

export default function ChatIndex(props) {
    const {...rest} = props;
    const location = useLocation();
    let {id} = useParams();
    const [open, setOpen] = React.useState(true);
    const [currentRoute, setCurrentRoute] = React.useState("All Chats");
    let allfilters = useSelector(state => state.filters);
    let AllChats = useSelector(state => state.AllChats);
    const navigate = useNavigate();

    console.log("id", id)

    React.useEffect(() => {
        window.addEventListener("resize", () =>
            window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
        );
    }, [])

    ;
    React.useEffect(() => {
        // getActiveRoute(routes);
    }, [location.pathname]);


    // const getActiveRoute = (routes) => {
    //     let activeRoute = "Main Dashboard";
    //     for (let i = 0; i < routes.length; i++) {
    //         if (
    //             window.location.href.indexOf(
    //                 routes[i].layout + "/" + routes[i].path
    //             ) !== -1
    //         ) {
    //             setCurrentRoute(routes[i].name);
    //         }
    //     }
    //     return activeRoute;
    // };




    const navigateNext = () => {
        let all = applyFilters(AllChats, allfilters);
        var elementPos = all.map(function(x) {return x.FileName; }).indexOf(id);

        let next = elementPos + 1;

        if (next < all.length){
            let item = all[next];
            navigate(`/all-chats/${item.FileName}`);
        }else{
            let item = all[0];
            navigate(`/all-chats/${item.FileName}`);
        }
    }


    const navigateBack = () => {
        let all = applyFilters(AllChats, allfilters);
        var elementPos = all.map(function(x) {return x.FileName; }).indexOf(id);

        let previous = elementPos - 1;

        if (previous >= 0) {
            let item = all[previous];
            navigate(`/all-chats/${item.FileName}`);
        }else{
            let item = all[0];
            navigate(`/all-chats/${item.FileName}`);
        }
    }


    return (
        <div className="h-full">
            {id && <div className="flex flex-row-reverse border-0 justify-between">
                <MdOutlineNavigateNext onClick={() => navigateNext()} className={"h-7 w-7 cursor-pointer"}/>
                <MdNavigateBefore onClick={() => navigateBack()} className={"h-7 w-7 cursor-pointer"}/>
            </div>
            }

            <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
                {id ? <ChatDetailsComponent id={id}/> : <ChatListPage/>}
            </div>

        </div>

    );
}
